import _createClass from "/agent/_work/1/s/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/agent/_work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
export var HeaderNames = /*#__PURE__*/_createClass(function HeaderNames() {
  _classCallCheck(this, HeaderNames);
});
HeaderNames.Authorization = "Authorization";
HeaderNames.Cookie = "Cookie";